module.exports = __webpack_public_path__ + "img/05—Applications—VPN server—Create VPN credentials.41094e74.jpg";